import { createSelector } from 'reselect';
import { Folder, Nullable } from '@Models';
import { AppState } from '@Redux/store';
import { FolderView } from '../../myArmyList/common/ArmyListView';
import { getFolders } from '../../myBuilder/selector';
import { FolderState } from '@Stores/index';

const getFolderState = (state: AppState): FolderState => state.folder;

const getFolder = (state: AppState): Nullable<Folder> => state.folder.entity;

export const folderPresenter = createSelector(
  [getFolderState, getFolder, getFolders],
  (folderSate, folder, folders): FolderView => {
    return {
      id: folderSate.id ?? '',
      name: folder?.name ?? '',
      parentId: folder?.parentId ?? null,
      parentName:
        folder?.parentId != null
          ? (folders.find((item) => item.id === folder?.parentId)?.name ?? null)
          : null,
      isShare: folder?.isShare ?? false,
    } satisfies FolderView as FolderView;
  },
);
